import { createAction, props } from '@ngrx/store';

export const mainModuleLabels = {
  SET_SCREEN_INFORMATION__ID: 'MAIN_SET_SCREEN_ID',
  SET_SCREEN_INFORMATION__TITLE: 'MAIN_SET_SCREEN_TITLE',
  SET_SCREEN_INFORMATION__COMPANY: 'MAIN_SET_SCREEN_COMPANY',
  SET_SCREEN_LOADING: 'MAIN_SET_SCREEN_LOADING',
  SET_ALL_DEFAULT: 'MAIN_SET_ALL_DEFAULT',
  SET_SCREEN_INFORMATION__SHOW_HEADING: 'MAIN_SET_SCREEN_SHOW_HEADING',
};

export const screenActions = {
  setScreenIdAction: createAction(
    mainModuleLabels.SET_SCREEN_INFORMATION__ID,
    props<{ id?: string }>()
  ),
  setScreenTitleAction: createAction(
    mainModuleLabels.SET_SCREEN_INFORMATION__TITLE,
    props<{ title?: string }>()
  ),
  setScreenCompanyAction: createAction(
    mainModuleLabels.SET_SCREEN_INFORMATION__COMPANY,
    props<{ company?: string }>()
  ),
  setScreenLoadingAction: createAction(
    mainModuleLabels.SET_SCREEN_LOADING,
    props<{ loading: boolean }>()
  ),
  setAllDefaultAction: createAction(
    mainModuleLabels.SET_ALL_DEFAULT,
    props<any>()
  ),
  setScreenShowHeadingAction: createAction(
    mainModuleLabels.SET_SCREEN_INFORMATION__SHOW_HEADING,
    props<{ showHeading: boolean }>()
  ),
};
